// import axiosInstance from "../../../axios";
// import config from "../../../config";
// import { usePersistedStore } from "../../persisted-store";

// export const createTicketReportSlice = (set, get) => ({
//     crmTicketReport: {
//         loading: false,
//         data: []
//     },
//     getCrmTicketReport: async (UsrUserID) => {
//         const token = usePersistedStore.getState().business.currentBusiness.token;
//         set(state => ({ crmTicketReport: { ...state.crmTicketReport, loading: true } }));
//         try {
//             const resp = await axiosInstance({
//                 method: 'get',
//                 baseURL: config.apiUrls(),
//                 url: `v1/crm/ticket-report/user/${UsrUserID}`,
//                 headers: { token }
//             });
//             set(state => ({ crmTicketReport: { loading: false, data: resp.data } }));
//         } catch (error) {
//             set(state => ({ crmTicketReport: { ...state.crmTicketReport, loading: false } }));
//         }
//     }
// });
import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createTicketReportSlice = (set, get) => ({
    crmTicketReport: {
        loading: false,
        data: []
    },
    getCrmTicketReport: async (params) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmTicketReport: { ...state.crmTicketReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'post',
                baseURL: config.apiUrls(),
                url: `v1/crm/ticket-report/user/${params.usrUserID}`,
                headers: { token },
                data: {
                    PageNumber: params.PageNumber,
                    PageSize: params.PageSize,
                },
            });
            set(state => ({ crmTicketReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmTicketReport: { ...state.crmTicketReport, loading: false } }));
        }
    }
});

